import { render, staticRenderFns } from "./addOrEditBusiness.vue?vue&type=template&id=bd54a740&scoped=true"
import script from "./addOrEditBusiness.vue?vue&type=script&lang=js"
export * from "./addOrEditBusiness.vue?vue&type=script&lang=js"
import style0 from "./addOrEditBusiness.vue?vue&type=style&index=0&id=bd54a740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd54a740",
  null
  
)

export default component.exports